import { Vue } from 'vue-property-decorator'
import fetch from '@/helpers/fetch'

export default {
	generateStore,
}

function generateStore(name) {
	return {
		state: getState(name),
		mutations: getMutations(name),
		actions: getActions(name),
	}
}

function generateListName(name) {
	return name.toLowerCase() + 'List'
}

function getState(name) {
	const state = {}
	state[generateListName(name)] = null

	return state
}

function getMutations(name) {
	const mutations = {}
	const upperCaseName = name.toUpperCase()

	const setListName = 'SET_' + upperCaseName + '_LIST'
	mutations[setListName] = (state, list) => {
		state[generateListName(name)] = list
	}

	mutations['SET_' + upperCaseName] = (state, item) => {
		if (item.model) {
			Vue.set(state[generateListName(name)], item.index, item.model)
		} else {
			Vue.delete(state[generateListName(name)], item.index)
		}
	}

	mutations['ADD_' + upperCaseName] = (state, item) => {
		state[generateListName(name)].unshift(item.model)

		Vue.set(state[generateListName(name)], 0, item.model)
	}

	return mutations
}

function getActions(name) {
	const upperCaseName = name.toUpperCase()
	const lowerCaseName = name.toLowerCase()
	const actions = {}

	actions['fetch' + name] = async function (context): Promise<object[]> {
		const data = await fetch.get('/api/' + lowerCaseName)
		context.dispatch('set' + name + 'List', data.data)
		return data
	}

	actions['set' + name + 'List'] = function (context, data) {
		context.commit('SET_' + upperCaseName + '_LIST', data)
	}

	actions[lowerCaseName + 'Change'] = function (context, item) {
		context.commit('SET_' + upperCaseName, item)
	}

	actions[lowerCaseName + 'Add'] = async function (context, item) {
		if (!context.state[generateListName(name)]) {
			context.dispatch('set' + name + 'List', [])
		}

		context.commit('ADD_' + upperCaseName, item)
	}

	actions[lowerCaseName + 'Save'] = async function (context, list) {
		const data = await fetch.post('/api/' + lowerCaseName, list)
		context.commit('SET_' + upperCaseName + '_LIST', data)
		return data
	}

	return actions
}
